import { z } from 'zod';

import { AppKindEnum } from 'src/graphql/schema';

export const ownApplicationFormSchema = z
  .object({
    name: z.string().trim(),
    logo: z.union([z.instanceof(File), z.string()]).nullable(),
    kind: z.nativeEnum(AppKindEnum),
    includedApps: z.array(z.string()).optional(),
    criticality: z.string().min(1, 'Select a criticality.'),
    industry: z.string().min(1, 'Select an industry.'),
    softwareType: z.string().min(1, 'Select a software type.'),
    jurisdiction: z.string().min(1, 'Select a jurisdiction.'),
    description: z.string().optional(),
  })
  .superRefine(({ name, kind, includedApps }, ctx) => {
    if (!name) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['name'],
        message: kind === AppKindEnum.Suite ? 'Enter an application suite name.' : 'Enter an application name.',
      });
    }

    if (kind === AppKindEnum.Suite && !includedApps?.length) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['includedApps'],
        message: 'Add at least one application to this suite.',
      });
    }
  });

export type IOwnApplicationForm = z.infer<typeof ownApplicationFormSchema>;

export const ownApplicationFormDefaultValues: IOwnApplicationForm = {
  name: '',
  logo: null,
  kind: AppKindEnum.Single,
  includedApps: [],
  criticality: '',
  industry: '',
  softwareType: '',
  jurisdiction: '',
  description: '',
};
